import { render } from "./CurrencyInput_c.vue?vue&type=template&id=66c0483e"
import script from "./CurrencyInput_c.vue?vue&type=script&lang=js"
export * from "./CurrencyInput_c.vue?vue&type=script&lang=js"
script.render = render

export default script